/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ServerDefs from "./defs.defs.js";

const $nsid = "place.stream.server.updateWebhook";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"id":/*#__PURE__*/ l.string(),"url":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"events":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.enum(["chat","livestream","follow","mention","stream.received"]), )),"active":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"prefix":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"suffix":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"rewrite":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<ServerDefs.RewriteRule>((() => ServerDefs.rewriteRule) as any), )),"name":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":500})),"muteWords":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":100}), ))});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"webhook":/*#__PURE__*/ l.ref<ServerDefs.Webhook>((() => ServerDefs.webhook) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Update an existing webhook configuration. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["WebhookNotFound","Unauthorized","InvalidUrl","DuplicateWebhook"]);

export { main };

export const $lxm = $nsid;
